import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import './styles/index.css'
import App from './components/App'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import apiConfig from './config/apiConfig'

const config = {
  apiKey: apiConfig.auth.apiKey,
  serviceName: 'ziptieui',
  tracesUrl: apiConfig.api.otelTracesUrl,
  logsUrl: apiConfig.api.otelLogsUrl,
  metricsUrl: apiConfig.api.otelMetricsUrl,
}

const store = configureStore()
const rootEl = document.getElementById('root')
const root = createRoot(rootEl)

OpenTelemetryManager.initialize(config)

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default
    root.render(
      <Provider store={store}>
        <NextApp />
      </Provider>,
    )
  })
}
